import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { line } from '../slang-printers/prettier-builders.js';
import { printSeparatedList } from '../slang-printers/print-separated-list.js';
import { SlangNode } from './SlangNode.js';
import { InheritanceType } from './InheritanceType.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { AstPath, Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class InheritanceTypes extends SlangNode {
  readonly kind = NonterminalKind.InheritanceTypes;

  items: InheritanceType[];

  constructor(ast: ast.InheritanceTypes, collected: CollectedMetadata) {
    super(ast, collected, true);

    this.items = ast.items.map((item) => new InheritanceType(item, collected));
  }

  print(print: PrintFunction, path: AstPath<InheritanceTypes>): Doc {
    return printSeparatedList(path.map(print, 'items'), {
      firstSeparator: line
    });
  }
}
